export const hasPhoneNumberConfigured = <
  T extends {
    twilioNumber?: string;
    twilioNumbers?: string[];
    phoneLabels?: { number: string; label: string }[];
  },
>(
  org: T
): boolean => !!org?.twilioNumber || !!org?.twilioNumbers?.length || !!org?.phoneLabels?.length;
